import React, { useState, useContext, useEffect } from 'react';
import './Alert.css';


const Alert = ({
	title,
	description,
  	onClickAction,
	alertType
}) => {
  return (
    <div className={'alert '+alertType}>
      <span className='alert__closebtn' onClick={(e)=>{e.target.parentElement.style.visibility="hidden";e.target.parentElement.style.opacity = "0"}}>
        &times;
      </span>
      <div className='alert__text' onClick={(e)=>{document.querySelector('.alert').style.opacity = "0"; e.target.parentElement.style.visibility="hidden"; onClickAction()}}><strong>{title}</strong> {description}</div>
    </div>
  ); 
};


export default Alert;
